import { createModel } from '@/store/tools';

const model = {
    namespace: 'reportrecord',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getTableSource': T('getTableSource'),
            'getRecordDetail': T('getRecordDetail'),
            'getRecordTemplates': T('getRecordTemplates'),
        },
        actions: {
            'getTableSource': A('getTableSource'),
            'getRecordDetail': A('getRecordDetail'),
            'cleanRecordDetail': C('getRecordDetail'),
            'getRecordTemplates': A('getRecordTemplates'),
            'cleanRecordTemplates': C('getRecordTemplates'),
        },
        sagas: {
            'getTableSource': S('getTableSource', '/?cmd=com.xqxc.api.pig.mis.biz.platform.report.ReportRecordService.list'),
            'getRecordDetail': S('getRecordDetail', '/?cmd=com.xqxc.api.pig.mis.biz.platform.report.ReportRecordService.getById'),
            'getRecordTemplates': S('getRecordTemplates', '/?cmd=com.xqxc.api.pig.mis.biz.platform.report.ReportTemplateService.selectList'),
        },
        reducers: {
            'tableSource': R('getTableSource', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
            'recordDetail': R('getRecordDetail', { queryCriteriaList: [] }),
            'recordTemplates': R('getRecordTemplates', []),
        }
    })
};
export default createModel(model);